// src/pages/performance/manageAppraisals.constants.js
/* ---------------------------------------
   API Paths (match your Laravel routes)
---------------------------------------- */
export const API = {
  appraisals: "/performance/appraisals",
  questions: "/performance/questions",
  customizeWorkflow: (id) => `/performance/appraisals/${id}/customize-workflow`,
  assignStepAssignee: (appraisalId, stepId) =>
    `/performance/appraisals/${appraisalId}/steps/${stepId}/assign`,
  skipStep: (appraisalId, stepId) =>
    `/performance/appraisals/${appraisalId}/steps/${stepId}/skip`,
  bulkCreate: "/performance/appraisals/bulk-create",
  adminUsers: "/admin/users",
  workflowTemplates: "/performance/workflow-templates",
};

/* ---------------------------------------
   Constants
---------------------------------------- */
export const STATUS_OPTIONS = [
  { value: "", label: "All statuses" },
  { value: "draft", label: "Draft" },
  { value: "pending", label: "Pending" },
  { value: "in_progress", label: "In progress" },
  { value: "submitted", label: "Submitted" },
  { value: "completed", label: "Completed" },
  { value: "unassigned", label: "Unassigned" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
  { value: "cancelled", label: "Cancelled" },
];

// ✅ IMPORTANT: values MUST match backend slugs from your seeder
export const WORKFLOW_TEMPLATE_OPTIONS_FALLBACK = [
  { value: "", label: "Auto-select based on employee role (recommended)" },
  {
    value: "default_line_manager_employee_second_level",
    label: "Generic default chain (Direct Manager → Employee → Second Level → HR)",
  },
  {
    value: "appraisal_head_of_department",
    label: "Head of Department appraisals (CEO → Executive → HR)",
  },
  {
    value: "appraisal_project_manager",
    label: "Project Manager appraisals (HOD → Operation Manager → HR)",
  },
  {
    value: "appraisal_head_office_employee",
    label: "Head Office employee appraisals (HOD → Operation Manager → HR)",
  },
  {
    value: "appraisal_business_development",
    label: "Business Development appraisals (Operation Manager → CEO → HR)",
  },
  { value: "appraisal_hr_team", label: "HR Administration team appraisals" },
  { value: "appraisal_pmc_project_manager", label: "Project Manager (PMC) (Operations → HR)" },
];

export const APPLICABILITY_OPTIONS = [
  { value: "YES", label: "YES" },
  { value: "NO", label: "NO" },
  { value: "OPTIONAL", label: "OPTIONAL" },
];

export const CURRENT_YEAR = new Date().getFullYear();

export const PERIOD_OPTIONS = [
  { value: String(CURRENT_YEAR - 2), label: String(CURRENT_YEAR - 2) },
  { value: String(CURRENT_YEAR - 1), label: String(CURRENT_YEAR - 1) },
  { value: String(CURRENT_YEAR), label: String(CURRENT_YEAR) },
  { value: String(CURRENT_YEAR + 1), label: String(CURRENT_YEAR + 1) },
];

export const CYCLE_OPTIONS = [
  { value: "annual", label: "Annual" },
  { value: "mid_year", label: "Mid-year" },
  { value: "probation", label: "Probation" },
];
